import React, { PureComponent, ReactNode } from 'react'
import './spinner.scss'

export class Spinner extends PureComponent {
  public render(): ReactNode {
    return <div className="spinner" />
  }
}
